/* @flow */
import { takeLatest, call, put, fork, select } from 'redux-saga/effects'
import { error, success } from 'react-notification-system-redux'
import { I18n } from 'react-redux-i18n'
import _ from 'lodash'

import {
  GET_SHOPS,
  GET_SHOPS_SUCCESS,
  GET_SHOPS_FAILURE,
  CLOUD_SHOPS_IMG_FOLDER,
  UPDATE_ACCOUNT_FAVORITES_SUCCESS,
  ADD_TO_FAVORITE,
  SEARCH_ACTIVITY,
  SEARCH_SHOP,
  HIDE_LOADING,
  REMOVE_FAVORITE,
} from '../configs/constants'
import API from '../libs/api'

const api = new API()

/* Workers */
export function* fetchShops() {
  try {
    const shops = yield call([api, api.readDBOnce], '/shops')
    const shopList = _.values(shops)
    for (let shop of shopList) {
      if (shop.photos.length) {
        // shop.thumb = yield call([api, api.getStorageUrl], CLOUD_SHOPS_IMG_FOLDER + shop.photos[0])
        shop.photos = yield shop.photos.map((photo) => {
          if (photo.url) {
            return photo.url
          } else {
            return call([api, api.getStorageUrl], CLOUD_SHOPS_IMG_FOLDER + photo)
          }
        })
        shop.thumb = shop.photos[0]
      }
    }
    yield put({ type: GET_SHOPS_SUCCESS, shops: shopList })
    yield put({ type: HIDE_LOADING })
  } catch (err) {
    yield put({ type: GET_SHOPS_FAILURE, err })
    yield put(error({ title: 'Error ' + err.code, message: err.message }))
  }
}

export function* addToFavorite({ type, payload }) {
  try {
    const favoritePath = '/accounts/' + payload.account.uid + '/favorites'
    yield call([api, api.pushDB], favoritePath, { shopId: payload.shopId })
    const favorites = yield call([api, api.readDBOnce], favoritePath)
    yield put({ type: UPDATE_ACCOUNT_FAVORITES_SUCCESS, favorites })
    yield put(success({ message: I18n.t('addFavoriteSuccess') }))
  } catch (err) {
    yield (put(error({ title: 'Error: ' + err.code, message: err.message })))
  }
}

export function* removeFavorite({ type, payload }) {
  try {
    const favoritePath = '/accounts/' + payload.account.uid + '/favorites/' + payload.key
    let newFavorites = payload.account.favorites
    delete newFavorites[payload.key]
    yield call(api.removeFromDB, favoritePath)
    yield put(success({ message: I18n.t('removeFavoriteSuccess') }))
    yield put({ type: UPDATE_ACCOUNT_FAVORITES_SUCCESS, favorites: newFavorites })
  } catch (err) {
    yield put(error({ title: 'Remove Favorite Encounters an Error: ' + err.code, message: err.message }))
  }
}

export function* searchActivites({ type, payload }) {
  const shops = yield select((state) => state.shop.shops)
  const filtered = payload.keyword ? shops.filter( (shop) => _.findKey(payload.keyword, (item) => shop.location === item) ) : shops
  const { startDate, endDate, experience } = payload
  yield put({
    type: SEARCH_ACTIVITY,
    payload: {
      shopIds: filtered.map(shop => shop.id),
      startDate,
      endDate,
      experience: experience || 0
    }
  })
}

/* Watchers */
function* shopWatcher() {
  yield takeLatest(GET_SHOPS, fetchShops)
}

function* addToFavoriteWatcher() {
  yield takeLatest(ADD_TO_FAVORITE, addToFavorite)
}

function* removeFavoriteWatcher() {
  yield takeLatest(REMOVE_FAVORITE, removeFavorite)
}

function* searchShopActivityWatcher() {
  yield takeLatest(SEARCH_SHOP, searchActivites)
}

export default [
  fork(shopWatcher),
  fork(addToFavoriteWatcher),
  fork(removeFavoriteWatcher),
  fork(searchShopActivityWatcher),
]


// WEBPACK FOOTER //
// ./src/sagas/shopSaga.js